import { IconMessageCircle2Filled } from "@tabler/icons-react"

import { BlueActionButton } from "@/components/generic/BlueActionButton"

export function HeaderButtonSupport() {
  return (
    <BlueActionButton
      aria-label="Support Chat"
      className="!min-h-[36px] !min-w-[36px]"
      data-testid="btn-show-support-chat"
    >
      <IconMessageCircle2Filled className="size-4" />
    </BlueActionButton>
  )
}
